export addGitHubFile from './addGitHubFile';
export cleanUpTmpPatchFiles from './cleanUpTmpPatchFiles';
export clearEditPatchForm from './clearEditPatchForm';
export clearSourceFileErrors from './clearSourceFileErrors';
export clientAddPatchStar from './clientAddPatchStar';
export clientRemovePatchStar from './clientRemovePatchStar';
export closeDialog from './closeDialog';
export compilePatch from './compilePatch';
export connectToOwl from './connectToOwl';
export deletePatch from './deletePatch';
export deleteDevicePresetFromSlot from './deleteDevicePresetFromSlot';
export deleteDeviceResourceFromSlot from './deleteDeviceResourceFromSlot';
export deviceDispatchPresetReceived from './deviceDispatchPresetReceived';
export deviceDispatchResourceReceived from './deviceDispatchResourceReceived';
export deviceDispatchProgramChange from './deviceDispatchProgramChange';
export deviceDispatchControlChange from './deviceDispatchControlChange';
export deviceDispatchDeviceUUIDReceived from './deviceDispatchDeviceUUIDReceived';
export eraseDeviceStorage from './eraseDeviceStorage';
export fetchAuthors from './fetchAuthors';
export fetchCurrentUser from './fetchCurrentUser';
export fetchPatchSourceCodeFiles from './fetchPatchSourceCodeFiles';
export fetchPatchDetails from './fetchPatchDetails';
export fetchPatches from './fetchPatches';
export fetchPatchesAuthorsTags from './fetchPatchesAuthorsTags';
export fetchPatchJavaScriptFile from './fetchPatchJavaScriptFile';
export fetchTags from './fetchTags';
export gitHubURLFieldChange from './gitHubURLFieldChange';
export loadPatchInToEditPatchForm from './loadPatchInToEditPatchForm';
export loadAndRunPatchOnDevice from './loadAndRunPatchOnDevice';
export newDialog from './newDialog';
export owlDispatchFirmWareVersion from './owlDispatchFirmWareVersion';
export owlDispatchPatchStatus from './owlDispatchPatchStatus';
export owlDispatchProgramMessage from './owlDispatchProgramMessage';
export owlDispatchProgramError from './owlDispatchProgramError';
export removeUploadedPatchFile from './removeUploadedPatchFile';
export removeGitHubFile from './removeGitHubFile';
export resetDevice from './resetDevice';
export resetPatchJavaScriptFile from './resetPatchJavaScriptFile';
export resetPatchListSubFilter from './resetPatchListSubFilter';
export resetWebAudioPatch from './resetWebAudioPatch';
export resetWebAudioPatchParameters from './resetWebAudioPatchParameters';
export selectMidiInput from './selectMidiInput';
export selectMidiOutput from './selectMidiOutput';
export serverCreateOrUpdatePatch from './serverCreateOrUpdatePatch';
export serverSavePatchFiles from './serverSavePatchFiles';
export serverAddPatchStar from './serverAddPatchStar';
export serverRemovePatchStar from './serverRemovePatchStar';
export serverUpdatePatch from './serverUpdatePatch';
export serverUploadPatchFiles from './serverUploadPatchFiles';
export setActiveDialogTab from './setActiveDialogTab';
export setMainSourceFile from './setMainSourceFile';
export setPatchListSearchTerm from './setPatchListSearchTerm';
export setPatchListTopFilter from './setPatchListTopFilter';
export setPatchPlaying from './setPatchPlaying';
export setPatchStarAndSendToSever from './setPatchStarAndSendToSever';
export setWebAudioPatch from './setWebAudioPatch';
export setWebAudioPatchParameter from './setWebAudioPatchParameter';
export setMIDIPatchParameter from './setMIDIPatchParameter';
export sourceFileChange from './sourceFileChange';
export storePatchInDeviceSlot from './storePatchInDeviceSlot';
export storeResourceOnDevice from './storeResourceOnDevice';
export togglePatchListSubFilter from './togglePatchListSubFilter';
export updateCompilationType from './updateCompilationType';
export updatePatchSourceCodeFile from './updatePatchSourceCodeFile';
export updatePatchName from './updatePatchName';



// WEBPACK FOOTER //
// ./src/actions/index.js